import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import DEVICE_TYPES from '../../enums/device/deviceTypes';
import {makeSelectAssetByType} from '../../state/selectors/yapEncrypted';
import {getState} from '../../state/store';
import devicePlatformService from '../device/devicePlatformService';
import deviceTypesService from '../device/deviceTypesService';
import amplitude from './amplitude';

const trackGlobalDataCollectionCompleted = (isHolder) => {
    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.DEVICE_DATA_COLLECTION_COMPLETED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.DATA_SYNC_COMPLETED]: true,
        },
    });
};

const trackDeviceGlobalDataCollectionError = () => {
    amplitude.trackDeviceEvent(AMPLITUDE_EVENT_TYPES.DEVICE_DATA_COLLECTION_COMPLETED, {
        [AMPLITUDE_EVENT_PROPERTIES.DATA_SYNC_COMPLETED]: false,
    });
};

const trackHolderDataCollectionError = () => {
    // serialNumber is taken from assets - because the event can be sent after the holder is removed
    const holderAsset = makeSelectAssetByType(true)(getState());
    const {serialNumber} = holderAsset || {};
    const isOriginalDuoDevice = deviceTypesService.isOriginalsDuoDeviceByCodeOrMaterial(holderAsset);
    const deviceType = isOriginalDuoDevice
        ? DEVICE_TYPES.DEV_TYPE_P1V31_ORIGINALS_HOLDER
        : devicePlatformService.getDeviceTypeBySerialNumber(serialNumber);

    amplitude.trackEvent({
        eventType: AMPLITUDE_EVENT_TYPES.DEVICE_DATA_COLLECTION_COMPLETED,
        deviceType,
        serialNumber,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.DATA_SYNC_COMPLETED]: false,
        },
    });
};

const trackGlobalDataCollectionError = (isHolder) => {
    if (isHolder) {
        trackHolderDataCollectionError();
    } else {
        trackDeviceGlobalDataCollectionError();
    }
};

export default {
    trackGlobalDataCollectionCompleted,
    trackGlobalDataCollectionError,
};
